function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import * as React from 'react';
import { getOverrides } from '../helpers/overrides';
import { StyledInnerXXSmallAnchor, StyledOuterXXSmallAnchor, StyledInnerXSmallAnchor, StyledOuterXSmallAnchor, StyledPinHead, RelativeContainer, StyledEnhancerSlot, StyledLabelSlot, StyledLabel } from './styled-components';
import { PINHEAD_DIMENSIONS, PINHEAD_TYPES, PINHEAD_SIZES_SHAPES, NEEDLE_HEIGHTS, NEEDLE_SIZES } from './constants';
import BadgeEnhancer from './badge-enhancer';
import LabelEnhancer from './label-enhancer';

var PinHead = function PinHead(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? PINHEAD_SIZES_SHAPES.medium : _ref$size,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$secondaryLabel = _ref.secondaryLabel,
      secondaryLabel = _ref$secondaryLabel === void 0 ? '' : _ref$secondaryLabel,
      StartEnhancer = _ref.startEnhancer,
      EndEnhancer = _ref.endEnhancer,
      color = _ref.color,
      background = _ref.background,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? PINHEAD_TYPES.fixed : _ref$type,
      anchorType = _ref.anchorType,
      _ref$needle = _ref.needle,
      needle = _ref$needle === void 0 ? NEEDLE_SIZES.none : _ref$needle,
      labelEnhancerContent = _ref.labelEnhancerContent,
      labelEnhancerPosition = _ref.labelEnhancerPosition,
      badgeEnhancerSize = _ref.badgeEnhancerSize,
      badgeEnhancerContent = _ref.badgeEnhancerContent,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;
  var activeElements = [label, StartEnhancer, EndEnhancer].filter(function (x) {
    return x;
  });
  var gridTemplateColumns = activeElements.map(function () {
    return 'auto';
  }).join(' ');
  var forceCircle = activeElements.length === 1 && !label;
  var _PINHEAD_DIMENSIONS$s = PINHEAD_DIMENSIONS[size],
      height = _PINHEAD_DIMENSIONS$s.height,
      icon = _PINHEAD_DIMENSIONS$s.icon;

  var _getOverrides = getOverrides(overrides.PinHead, StyledPinHead),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      PinHead = _getOverrides2[0],
      pinHeadProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.EnhancerSlot, StyledEnhancerSlot),
      _getOverrides4 = _slicedToArray(_getOverrides3, 2),
      EnhancerSlot = _getOverrides4[0],
      enhancerSlotProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(overrides.LabelSlot, StyledLabelSlot),
      _getOverrides6 = _slicedToArray(_getOverrides5, 2),
      LabelSlot = _getOverrides6[0],
      labelSlotProps = _getOverrides6[1];

  var _getOverrides7 = getOverrides(overrides.Label, StyledLabel),
      _getOverrides8 = _slicedToArray(_getOverrides7, 2),
      Label = _getOverrides8[0],
      labelProps = _getOverrides8[1];

  var _getOverrides9 = getOverrides(overrides.SecondaryLabel, StyledLabel),
      _getOverrides10 = _slicedToArray(_getOverrides9, 2),
      SecondaryLabel = _getOverrides10[0],
      secondaryLabelProps = _getOverrides10[1];

  var _getOverrides11 = getOverrides(overrides.InnerAnchor, StyledInnerXXSmallAnchor),
      _getOverrides12 = _slicedToArray(_getOverrides11, 2),
      InnerXXSmallAnchor = _getOverrides12[0],
      innerXXSmallAnchorProps = _getOverrides12[1];

  var _getOverrides13 = getOverrides(overrides.OuterAnchor, StyledOuterXXSmallAnchor),
      _getOverrides14 = _slicedToArray(_getOverrides13, 2),
      OuterXXSmallAnchor = _getOverrides14[0],
      outerXXSmallAnchorProps = _getOverrides14[1];

  var _getOverrides15 = getOverrides(overrides.InnerAnchor, StyledInnerXSmallAnchor),
      _getOverrides16 = _slicedToArray(_getOverrides15, 2),
      InnerXSmallAnchor = _getOverrides16[0],
      innerXSmallAnchorProps = _getOverrides16[1];

  var _getOverrides17 = getOverrides(overrides.OuterAnchor, StyledOuterXSmallAnchor),
      _getOverrides18 = _slicedToArray(_getOverrides17, 2),
      OuterXSmallAnchor = _getOverrides18[0],
      outerXSmallAnchorProps = _getOverrides18[1];

  var badge = /*#__PURE__*/React.createElement(BadgeEnhancer, {
    markerType: type,
    pinHeadSize: size,
    badgeEnhancerSize: badgeEnhancerSize,
    badgeEnhancerContent: badgeEnhancerContent,
    overrides: overrides
  });

  if (type === PINHEAD_TYPES.fixed && (size === PINHEAD_SIZES_SHAPES.xxSmallCircle || size === PINHEAD_SIZES_SHAPES.xxSmallSquare)) {
    var round = size === PINHEAD_SIZES_SHAPES.xxSmallCircle;
    return /*#__PURE__*/React.createElement(OuterXXSmallAnchor, _extends({
      $round: round,
      $background: background,
      $size: height
    }, outerXXSmallAnchorProps), /*#__PURE__*/React.createElement(InnerXXSmallAnchor, _extends({
      $color: color,
      $round: round,
      $size: icon
    }, innerXXSmallAnchorProps)));
  }

  if (type === PINHEAD_TYPES.fixed && (size === PINHEAD_SIZES_SHAPES.xSmallSquare || size === PINHEAD_SIZES_SHAPES.xSmallCircle)) {
    var _round = size === PINHEAD_SIZES_SHAPES.xSmallCircle;

    return /*#__PURE__*/React.createElement(RelativeContainer, null, badge, /*#__PURE__*/React.createElement(OuterXSmallAnchor, _extends({
      $round: _round,
      $background: background,
      $size: height
    }, outerXSmallAnchorProps), /*#__PURE__*/React.createElement(InnerXSmallAnchor, _extends({
      $color: color,
      $round: _round,
      $size: icon
    }, innerXSmallAnchorProps))));
  }

  var renderSecondaryLabel = (size === PINHEAD_SIZES_SHAPES.large || size === PINHEAD_SIZES_SHAPES.medium) && secondaryLabel;
  return /*#__PURE__*/React.createElement(RelativeContainer, null, /*#__PURE__*/React.createElement(LabelEnhancer, {
    labelEnhancerContent: labelEnhancerContent,
    labelEnhancerPosition: labelEnhancerPosition,
    needleHeight: NEEDLE_HEIGHTS[needle],
    size: size,
    overrides: overrides
  }), badge, /*#__PURE__*/React.createElement(PinHead, _extends({
    $background: background,
    $height: height,
    $gridTemplateColumns: gridTemplateColumns,
    $forceCircle: forceCircle,
    $type: type
  }, pinHeadProps), StartEnhancer && /*#__PURE__*/React.createElement(EnhancerSlot, _extends({
    $height: height,
    $color: color,
    $size: size
  }, enhancerSlotProps), /*#__PURE__*/React.createElement(StartEnhancer, {
    size: icon
  })), label && /*#__PURE__*/React.createElement(LabelSlot, labelSlotProps, /*#__PURE__*/React.createElement(Label, _extends({
    $size: size,
    $renderSecondaryLabel: renderSecondaryLabel,
    $color: color
  }, labelProps), label), renderSecondaryLabel && /*#__PURE__*/React.createElement(SecondaryLabel, _extends({
    $size: size,
    $renderSecondaryLabel: renderSecondaryLabel,
    $color: color
  }, secondaryLabelProps), secondaryLabel)), EndEnhancer && /*#__PURE__*/React.createElement(EnhancerSlot, _extends({
    $height: height,
    $color: color,
    $size: size
  }, enhancerSlotProps), /*#__PURE__*/React.createElement(EndEnhancer, {
    size: icon
  }))));
};

export default PinHead;